<template>
    <div id="bene-bank-transfer-container">
        <f7-list form class="form-group" v-if="showFormSet.bankTransfer">
            <f7-list-input
                input-id     ="bsbCode"
                name         ="bsbCode"
                type         ="text"

                v-if         ="showFormInput.bankTransfer.bsbCode"
                :label       ="bsbCodeLabel"
                :placeholder ="bsbCodeLabel"
                :value       ="bsbCode"
                @change      ="setBsbCode($event.target.value); validateInput($event.target); setInput('bsbCode');"

                maxlength    ="6"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="iban"
                name         ="iban"
                type         ="text"

                v-if         ="showFormInput.bankTransfer.iban"
                :label       ="$t('beneficiary-iban')"
                :placeholder ="$t('beneficiary-iban')"
                :value       ="iban"
                @change      ="setIban($event.target.value); validateInput($event.target); setInput('iban');"

                maxlength    ="30"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="swiftCode"
                name         ="swiftCode"
                type         ="text"

                v-if         ="showFormInput.bankTransfer.swiftCode"
                :label       ="$t('beneficiary-swift-code')"
                :placeholder ="$t('beneficiary-swift-code')"
                :value       ="swiftCode"
                @change      ="setSwiftCode($event.target.value); validateInput($event.target); setInput('swiftCode');"

                maxlength    ="30"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="sortCode"
                name         ="sortCode"
                type         ="number"

                v-if         ="showFormInput.bankTransfer.sortCode"
                :label       ="$t('beneficiary-sort-code')"
                :placeholder ="$t('beneficiary-sort-code')"
                :value       ="sortCode"
                @change      ="setSortCode($event.target.value); validateInput($event.target); setInput('sortCode');"

                maxlength    ="6"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'bsbCode',
                'iban',
                'swiftCode',
                'sortCode',
                'showPreloaderState',
                'forceRerenderKey',
                'isCreateBeneficiary',
                'bsbCodeLabel'
            ])
        },
        components: {
        },
        methods: {
            ...mapActions('beneficiary', [
                'setBsbCode',
                'setIban',
                'setSwiftCode',
                'setSortCode',
                'setShowPreloaderState'
            ]),

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>